/* LUMEDYA : comportements des sections « lmd » (galerie, offres, avis, carrousels, cartes qui se retournent, barre d'achat, vidéo). */
(function () {
  'use strict';

  var mouvementReduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tous(racine, selecteur) {
    return Array.prototype.slice.call(racine.querySelectorAll(selecteur));
  }

  // Galerie : piste à défilement horizontal (glissement au doigt natif), flèches, vignettes et compteur.
  function galerie(bloc) {
    var piste = bloc.querySelector('[data-lmd-diapos]');
    if (!piste) return;
    var diapos = tous(piste, '[data-lmd-diapo]');
    var vignettes = tous(bloc, '[data-lmd-vignette]');
    var bande = bloc.querySelector('[data-lmd-vignettes]');
    var rang = bloc.querySelector('[data-lmd-g-rang]');
    var total = diapos.length;
    var cible = -1;
    var minuterie = null;
    if (total < 2) return;

    function position() {
      var largeur = piste.clientWidth || 1;
      return Math.max(0, Math.min(total - 1, Math.round(piste.scrollLeft / largeur)));
    }

    function marquer(i) {
      if (rang) rang.textContent = String(i + 1);
      vignettes.forEach(function (vignette, k) {
        vignette.classList.toggle('est-active', k === i);
        if (k === i) vignette.setAttribute('aria-current', 'true');
        else vignette.removeAttribute('aria-current');
      });
      var active = vignettes[i];
      if (bande && active) {
        var gauche = active.offsetLeft - (bande.clientWidth - active.offsetWidth) / 2;
        bande.scrollTo({ left: Math.max(0, gauche), behavior: mouvementReduit ? 'auto' : 'smooth' });
      }
    }

    function aller(i, immediat) {
      i = ((i % total) + total) % total;
      cible = i;
      clearTimeout(minuterie);
      minuterie = setTimeout(function () { cible = -1; }, 800);
      marquer(i);
      piste.scrollTo({ left: i * piste.clientWidth, behavior: immediat || mouvementReduit ? 'auto' : 'smooth' });
    }

    piste.addEventListener('scroll', function () {
      var i = position();
      if (cible > -1) {
        if (i === cible) cible = -1;
        return;
      }
      marquer(i);
    }, { passive: true });

    piste.addEventListener('keydown', function (evenement) {
      if (evenement.key === 'ArrowRight') { evenement.preventDefault(); aller(position() + 1); }
      if (evenement.key === 'ArrowLeft') { evenement.preventDefault(); aller(position() - 1); }
    });

    var precedent = bloc.querySelector('[data-lmd-g-prec]');
    var suivant = bloc.querySelector('[data-lmd-g-suiv]');
    if (precedent) precedent.addEventListener('click', function () { aller((cible > -1 ? cible : position()) - 1); });
    if (suivant) suivant.addEventListener('click', function () { aller((cible > -1 ? cible : position()) + 1); });

    vignettes.forEach(function (vignette, k) {
      vignette.addEventListener('click', function () { aller(k); });
      // Éditeur de thème : sélectionner un bloc « Visuel » l'affiche.
      vignette.addEventListener('shopify:block:select', function () { aller(k, true); });
    });

    window.addEventListener('resize', function () {
      piste.scrollTo({ left: position() * piste.clientWidth, behavior: 'auto' });
    });
  }

  // Avis clients : « Voir plus d'avis » affiche les avis repliés.
  function temoignages(bloc) {
    var bouton = bloc.querySelector('[data-lmd-temoins-plus]');
    function ouvrir() { bloc.classList.add('est-ouvert'); }
    if (bouton) bouton.addEventListener('click', ouvrir);
    bloc.addEventListener('shopify:block:select', ouvrir);
  }

  function offres(achat) {
    var champId = achat.querySelector('[data-lmd-id]');
    var champQte = achat.querySelector('[data-lmd-qte]');
    var champs = tous(achat, '.lmd-offre__champ');
    if (!champId || !champQte || !champs.length) return;

    function choisir(champ) {
      champId.value = champ.getAttribute('data-variante');
      champQte.value = champ.getAttribute('data-qte');
      var prix = (champ.getAttribute('data-prix') || '').trim();
      tous(achat, '[data-lmd-prix]').forEach(function (zone) { zone.textContent = prix; });
      var ancien = (champ.getAttribute('data-ancien') || '').trim();
      tous(achat, '[data-lmd-ancien]').forEach(function (zone) { zone.textContent = ancien; zone.hidden = !ancien; });
      champs.forEach(function (c) {
        c.closest('.lmd-offre').classList.toggle('est-choisie', c === champ);
      });
    }

    champs.forEach(function (champ) {
      champ.addEventListener('change', function () { if (champ.checked) choisir(champ); });
    });
    // Retour arrière du navigateur : le bouton radio mémorisé peut différer de l'état initial.
    var coche = champs.filter(function (c) { return c.checked; })[0];
    if (coche) choisir(coche);
  }

  function barre(achat) {
    var bandeau = achat.querySelector('[data-lmd-barre]');
    var bouton = achat.querySelector('[data-lmd-bouton]');
    if (!bandeau || !bouton || !('IntersectionObserver' in window)) return;
    var boutonBarre = bandeau.querySelector('button');
    // La barre s'affiche dès que le bouton principal est passé au-dessus de l'écran.
    function regler() {
      var cadre = bouton.getBoundingClientRect();
      var visible = cadre.height > 0 && cadre.bottom <= 0;
      bandeau.classList.toggle('est-visible', visible);
      bandeau.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (boutonBarre) boutonBarre.tabIndex = visible ? 0 : -1;
    }
    new IntersectionObserver(regler).observe(bouton);
    // L'observateur ne prévient pas quand le bouton saute du dessus au dessous de l'écran sans le traverser.
    var enAttente = false;
    function demander() {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(function () { enAttente = false; regler(); });
    }
    window.addEventListener('resize', demander);
    // En capture : dans Horizon, à partir de 990 px, c'est .page-wrapper qui défile, pas le document.
    document.addEventListener('scroll', demander, { capture: true, passive: true });
  }

  function carrousel(bloc) {
    var piste = bloc.querySelector('[data-lmd-piste]');
    var prec = bloc.querySelector('[data-lmd-prec]');
    var suiv = bloc.querySelector('[data-lmd-suiv]');
    if (!piste || !prec || !suiv) return;

    function pas() {
      var carte = piste.firstElementChild;
      if (!carte) return piste.clientWidth;
      var ecart = parseFloat(getComputedStyle(piste).columnGap) || 0;
      return carte.getBoundingClientRect().width + ecart;
    }
    function etat() {
      var max = piste.scrollWidth - piste.clientWidth;
      bloc.classList.toggle('sans-defilement', max <= 2);
      prec.disabled = piste.scrollLeft <= 2;
      suiv.disabled = piste.scrollLeft >= max - 2;
    }
    prec.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: mouvementReduit ? 'auto' : 'smooth' }); });
    suiv.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: mouvementReduit ? 'auto' : 'smooth' }); });
    piste.addEventListener('scroll', etat, { passive: true });
    window.addEventListener('resize', etat);
    etat();
  }

  function retourne(carte) {
    var recto = carte.querySelector('[data-lmd-recto]');
    var verso = carte.querySelector('[data-lmd-verso]');
    if (!recto || !verso) return;
    // La face cachée sort de la tabulation et de la lecture d'écran.
    function regler(retournee) {
      carte.classList.toggle('est-retournee', retournee);
      [[recto, retournee], [verso, !retournee]].forEach(function (paire) {
        paire[0].inert = paire[1];
        paire[0].setAttribute('aria-hidden', paire[1] ? 'true' : 'false');
      });
    }
    carte.addEventListener('click', function (evenement) {
      var retournee = !carte.classList.contains('est-retournee');
      var parBouton = evenement.target.closest('[data-lmd-retourner]');
      regler(retournee);
      if (!parBouton) return;
      var suivant = (retournee ? verso : recto).querySelector('[data-lmd-retourner]');
      if (suivant) suivant.focus({ preventScroll: true });
    });
    regler(false);
  }

  function video(element) {
    element.muted = true;
    if (!('IntersectionObserver' in window)) {
      element.play();
      return;
    }
    new IntersectionObserver(function (entrees) {
      if (entrees[0].isIntersecting) {
        var lecture = element.play();
        if (lecture && lecture.catch) lecture.catch(function () { element.controls = true; });
      } else {
        element.pause();
      }
    }, { threshold: 0.4 }).observe(element);
  }

  function versAchat(lien) {
    lien.addEventListener('click', function (evenement) {
      var cible = document.getElementById('lmd-achat');
      if (!cible) return;
      evenement.preventDefault();
      cible.scrollIntoView({ behavior: mouvementReduit ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function versAvis(lien) {
    lien.addEventListener('click', function (evenement) {
      var cible = document.getElementById('lmd-liste-avis') || document.getElementById('lmd-avis');
      if (!cible) return;
      evenement.preventDefault();
      cible.scrollIntoView({ behavior: mouvementReduit ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function demarrer(racine) {
    function unique(selecteur, action) {
      tous(racine, selecteur).forEach(function (element) {
        if (element.lmdPret) return;
        element.lmdPret = true;
        action(element);
      });
    }
    unique('[data-lmd-galerie]', galerie);
    unique('[data-lmd-temoins]', temoignages);
    unique('[data-lmd-achat]', function (achat) { offres(achat); barre(achat); });
    unique('[data-lmd-carrousel]', carrousel);
    unique('[data-lmd-retourne]', retourne);
    unique('[data-lmd-video]', video);
    unique('[data-lmd-vers-achat]', versAchat);
    unique('[data-lmd-vers-avis]', versAvis);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  } else {
    demarrer(document);
  }
  // Éditeur de thème : une section rechargée doit être rebranchée.
  document.addEventListener('shopify:section:load', function (evenement) { demarrer(evenement.target); });
})();
